<template>
  <div>
    <div class="w-full flex -mb-10">
      <report-date-picker v-model="dateRange"/>
    </div>
    <tabs pills
          type="secondary"
          style-type="list"
          tab-nav-classes="d-flex justify-content-end"
          tab-content-classes="tab-space">
      <tab-pane v-for="stat in stats"
                :key="stat.name"
                :before-change="() => getData(stat.name)"
                :title="$t(`generic.filters.${stat.name}`)"
                :id="stat.name">
        <div class="row d-flex">

          <div class="col-lg-4 col-md-6">
            <stats-card :title="getSumFor('jobsData', 'total')"
                        :loading="statsLoading"
                        class="job-board-stats"
                        :small-title="$t('generic.createdJobs')"
                        type="info"
                        icon="nc-icon nc-single-copy-04">
            </stats-card>
          </div>

          <div class="col-lg-4 col-md-6">
            <stats-card :title="getSumFor('eventsData', 'apply_views')"
                        :loading="statsLoading"
                        class="job-board-stats"
                        :small-title="$t('generic.views')"
                        type="success"
                        icon="nc-icon nc-sound-wave">
            </stats-card>
          </div>

          <div class="col-lg-4 col-md-6">
            <stats-card :title="getSumFor('eventsData', 'apply_starts')"
                        :loading="statsLoading"
                        class="job-board-stats"
                        :small-title="$t('generic.applyStart')"
                        type="info"
                        icon="nc-icon nc-paper">
            </stats-card>
          </div>
          <div class="col-lg-4 col-md-6">
            <stats-card :title="getSumFor('applicantsData', 'total')"
                        :loading="statsLoading"
                        class="job-board-stats"
                        :small-title="$t('generic.applicants')"
                        type="warning"
                        icon="nc-icon nc-chart-pie-36">
            </stats-card>
          </div>
          <div class="col-lg-4 col-md-6">
            <stats-card :title="getSumFor('ordersData', 'total')"
                        :loading="statsLoading"
                        class="job-board-stats"
                        :small-title="$t('generic.orders')"
                        type="success"
                        icon="nc-icon nc-tap-01">
            </stats-card>
          </div>
          <div class="col-lg-4 col-md-6">
            <stats-card :title="getSumFor('ordersData', 'orders_sales') | toCurrency"
                        :loading="statsLoading"
                        class="job-board-stats"
                        :small-title="$t('generic.sales')"
                        type="info"
                        icon="nc-icon nc-shop">
            </stats-card>
          </div>
        </div>
      </tab-pane>
    </tabs>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <jobs-per-product-report :job_board_id="$route.params.id"
                               :date-from="dateFrom"
                               :date-till="dateTill"/>

      <jobs-per-client-report :job_board_id="$route.params.id"
                              :date-from="dateFrom"
                              :date-till="dateTill"
                              @data-loaded="onJobsLoaded"
      />

      <events-report :job_board_id="$route.params.id"
                     :date-from="dateFrom"
                     :date-till="dateTill"
                     @data-loaded="onEventsLoaded"
      />
    </div>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import ReportDatePicker from 'src/views/admin/reports/ReportDatePicker'
  import { Tabs, TabPane, StatsCard } from 'src/components'
  import { mapState } from 'vuex'
  import JobsPerProductReport from 'src/views/admin/reports/JobsPerProductReport'
  import JobsPerClientReport from 'src/views/admin/reports/JobsPerClientReport'
  import EventsReport from 'src/views/admin/reports/EventsReport'
  import ReportService from '../../../../services/ReportService'
  import { getDefaultRange } from '@/views/admin/reports/defaultReportRange'
  export default {
    name: 'job-board-dashboard',
    components: {
      Tabs,
      TabPane,
      StatsCard,
      ReportDatePicker,
      JobsPerClientReport,
      JobsPerProductReport,
      EventsReport,
    },
    data () {
      const year = new Date().getFullYear()
      const defaultRange = getDefaultRange()
      return {
        year,
        defaultRange,
        dateRange: [...defaultRange],
        statsLoading: true,
        activeStat: 'total',
        model: {
          views: 0,
          click_out: 0,
          apply_start: 0,
          applicants: 0,
          orders: 0,
          jobs: 0
        },
        eventsData: {},
        jobsData: {},
        applicantsData: {},
        ordersData: {},
        stats: [
          {
            name: 'total'
          },
          {
            name: 'today'
          },
          {
            name: 'week'
          },
          {
            name: 'month'
          },
        ]
      }
    },
    computed: {
      ...mapState('jobs', {
        jobBoard: state => state.currentJobBoard
      }),
      dateFrom () {
        return get(this.dateRange, '[0]', this.defaultRange[0])
      },
      dateTill () {
        return get(this.dateRange, '[1]', this.defaultRange[1])
      },
    },
    methods: {
      getSumFor (type, property) {
        let total = 0
        get(this[type], 'results', []).forEach(item => {
          let value = item[property] || 0
          if (typeof value === 'string') {
            value = parseFloat(value)
          }
          total += value
        })
        return total
      },
      onEventsLoaded(data) {
        this.eventsData = data
      },
      onJobsLoaded(data) {
        this.jobsData = data
      },
      async getApplicantsData() {
        try {
          this.statsLoading = true
          const {data} = await ReportService.get({
            model: 'applicants',
            group: 'month',
            select: 'id,total',
            date_range: 'custom',
            date_from: this.dateFrom,
            date_till: this.dateTill,
            sort: 'date_month',
          })
          this.applicantsData = data
        } finally {
          this.statsLoading = false
        }
      },
      async getOrdersData() {
        try {
          this.statsLoading = true
          const {data} = await ReportService.get({
            model: 'orders',
            group: 'month',
            select: 'id,total,orders_sales',
            date_range: 'custom',
            date_from: this.dateFrom,
            date_till: this.dateTill,
            sort: 'date_month',
          })
          this.ordersData = data
        } finally {
          this.statsLoading = false
        }
      },
      async getData() {
        await Promise.all([
          this.getOrdersData(),
          this.getApplicantsData(),
        ])
      }
    },
    async created() {
      await this.getData()
    },
    watch: {
      async dateFrom () {
        await this.getData()
      },
      async dateTill () {
        await this.getData()
      }
    }
  }
</script>
